<template>
  <div>
    <mdb-card class="mb-4">
      <mdb-card-header>Recent Event Images</mdb-card-header>
      <mdb-card-body v-if="error">
        <error :error="error"/>
      </mdb-card-body>
      <mdb-card-body v-if="imageData">
        <mdb-carousel :items="imageData.length" controlls indicators multi slide>
          <template #[i+1] v-for="(img,i) in imageData">
            <mdb-card :key="i">
              <mdb-card-image :src="img.thumbUrl" :alt="'Image of '+img.title" @click.native="showLightbox(i)"
                              class="clickable"></mdb-card-image>
              <mdb-card-body>
                <router-link :to="img.linkUrl" v-if="img.linkUrl">
                  {{ img.title }}
                </router-link>
                <span v-if="!img.linkUrl">{{ img.title }}</span>
              </mdb-card-body>
            </mdb-card>
          </template>
        </mdb-carousel>
      </mdb-card-body>
    </mdb-card>
    <cust-lightbox :visible="lbVisible" :imgs="lbImgs" :index="lbIndex" @hide="handleHide"></cust-lightbox>
  </div>
</template>

<script>
import error from '../common/Error'
import CustLightbox from "../common/CustLightbox";
import {
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbCardImage,
  mdbCardText,
  mdbCardTitle,
  mdbCarousel,
  mdbContainer,
} from 'mdbvue';

export default {
  name: 'imageSection',
  components: {
    mdbContainer,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbCardImage,
    mdbCardText,
    mdbCardTitle,
    mdbCarousel,
    CustLightbox,
    error
  },
  props: {
    group: {
      type: Object,
      default: null
    },
    section: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      imageData: null,
      error: false,
      lbVisible: false,
      lbIndex: 0,
      lbImgs: []

    };
  },
  mounted() {
    if (!this.group) {
      return
    }
    this.imageData = this.section.data
    this.section.data.forEach(img => {
                                this.lbImgs.push(img.imageUrl)
                              }
    )
  },
  methods: {
    showLightbox(index) {
      this.lbIndex = index
      this.lbVisible = true
    },
    handleHide() {
      this.lbVisible = false
    },
  }
};
</script>
